import { autoinject } from "aurelia-framework";
import environment from 'environment';
import { Auth } from "../../framework/auth_support/af-auth";

@autoinject
export class ApiClientConfiguration {
  constructor(public auth: Auth) {
  }

  public basePath: string = environment.apiUrl;
}
